import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CapacityDialogActions = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(3),
}));
